export default [
  {
    path: "/",
    name: "Home",
  },
  {
    path: "/project",
    name: "Project",
  },
  {
    path: "/blog",
    name: "Blog",
  },
  {
    path: "/contact",
    name: "Contact",
  },
]
